import { FilterFieldType } from '@common/models';

import { OData } from './odata';

export class ODataFilter<T> extends OData
{
    protected static count: boolean = true;
    protected field4Filter: Map<string, FilterFieldType>;
    private _filter: T;
    get filter ()
    {
        return this._filter;
    }

    constructor (incrSize: number, nbItems?: number)
    {
        super(incrSize, nbItems);
    }

    protected processFilter (filter: T)
    {
        this._filter = {} as T;
        Object.assign(this._filter, filter);

        let qsFilterField: string;
        const qsFilterArray = [];

        let filterQueyString = '';

        this.field4Filter.forEach((value: FilterFieldType, key: string) =>
        {
            if (filter[key] !== null && filter[key] !== undefined && filter[key] !== '')
            {
                switch (value.type)
                {
                    case 'int':
                        qsFilterField = this.processByInt(value.name, filter[key]);

                        break;

                    case 'string':
                        qsFilterField = this.processByString(value.name, filter[key]);

                        break;

                    case 'boolean':
                        qsFilterField = this.processByBoolean(value.name, filter[key]);

                        break;

                    case 'switch':
                        qsFilterField = this.processByBoolean(value.name, [filter[key]]);

                        break;

                    case 'date':
                        qsFilterField = this.processByDate(key, value.name, filter[key]);

                        break;
                }

                if (qsFilterField !== null)
                {
                    qsFilterArray.push(qsFilterField);
                }
            }
        });

        filterQueyString += qsFilterArray.join(' and ');
        if (filterQueyString !== '')
        {
            this.pushValue('$filter', filterQueyString);
        }
    }

    private processByString (qsField: string, value: string | string[]): string
    {
        if (Array.isArray(value))
        {
            if (value.length === 0)
            {
                return null;
            }

            if (value.length > 1)
            {
                const val = value.join(',');

                return `${qsField} in (${val})`;
            }

            return `${qsField} eq ${value[0]}`;
        }

        return null;
    }

    private processByInt (qsField: string, value: number[]): string
    {
        if (value.length === 0)
        {
            return null;
        }

        if (value.length > 1)
        {
            const val = value.join(',');

            return `${qsField} in (${val})`;
        }

        return `${qsField} eq ${value[0]}`;
    }

    private processByBoolean (qsField: string, value: boolean[]): string
    {
        if (value.length === 0)
        {
            return null;
        }

        if (value.length > 1)
        {
            return '';
        }

        return `${qsField} is ${value[0]}`;
    }

    private processByDate (formField: string, qsField: string, value: string): string
    {
        const oper = formField === 'since' ? 'gte' : 'lte';

        if (!value)
        {
            return null;
        }

        return `${qsField} ${oper} ${value}`;
    }
}
